import styles from './index.module.less'
import ChatList from '@/pages/messageChat/ChatList'
import {Col, Row, Spin} from 'antd'
import useChatStore from '@/store/chatStore.ts'
import {useShallow} from 'zustand/react/shallow'
import classNames from 'classnames'
import {useDebounceEffect, useSetState} from 'ahooks'
import {getTodoItem, getTodoList} from '@/services/workorder.ts'
import chat from '@/model/Chat.ts'
import {useCallback, useRef} from 'react'
import {throttle} from 'lodash-es'
import ChatDialog from '@/pages/messageChat/ChatDialog'
import {triggerEvent} from '@/utils/customEvent.ts'
import {useActivate} from 'react-activation'

const getKey = chatState =>
  chatState.chatTabKey +
  chatState.todoTabKey +
  chatState.activeDict?.[chatState.chatTabKey + chatState.todoTabKey]?.id

let fetchMoreTimer: any = null

function TodoList(props: any) {
  const { setChatNoMore, navigateFlow, setChatLoading } = props
  const [state, setState] = useSetState({
    loading: false,
  })
  const {
    chatState,
    setChatState,
    setTodoData,
    todoData,
    messageData,
    setMessageData,
    pullDialogData,
  } = useChatStore(
    useShallow((state: any) => ({
      chatState: state.chatState,
      setChatState: state.setChatState,
      setTodoData: state.setTodoData,
      todoData: state.todoData,
      messageData: state.messageData,
      setMessageData: state.setMessageData,
      pullDialogData: state.pullDialogData,
    }))
  )

  const fetchTodoList = async () => {
    if (!todoData[chatState.todoTabKey]?.length) {
      setState({ loading: true })
    }
    const tab = chatState.todoTabKey
    return getTodoList({ tab })
      .then(res => {
        const data = chat.convertTodo(res)
        setTodoData(tab, data)
      })
      .finally(() => setState({ loading: false }))
  }

  const fetchTodoMessage = async (record, lastItem?) => {
    const todoKey = getKey(chatState)
    setChatLoading(todoKey, true)
    // console.log('lastItem', lastItem)

    // getTodoItem({
    //   tab: chatState.todoTabKey,
    //   // appCode: record.code,
    //   // minId: lastItem?.id,
    // }).then(res => {
    //   // console.log('todo list', res)
    // })

    return getTodoItem({
      tab: chatState.todoTabKey,
      appCode: record.code,
      minId: lastItem?.id,
    })
      .then((res: any) => {
        const messageItems =
          res?.map?.(item => chat.convertTodoMessage(record, item, navigateFlow)) || []
        if (messageItems.length < 10) {
          setChatNoMore(todoKey, true)
        }
        return messageItems
      })
      .finally(() => {
        setChatLoading(todoKey, false)
      })
  }

  const fetchMore = () => {
    const key = getKey(chatState)
    // console.log('fetchMore', key)
    pullDialogData(fetchTodoMessage, {
      key,
      active: chatState.activeDict[chatState.chatTabKey + chatState.todoTabKey],
    })
  }

  const fetchList = () => {}

  useDebounceEffect(
    () => {
      fetchTodoList()
    },
    [chatState.todoTabKey],
    { wait: 100 }
  )

  useActivate(() => {
    fetchTodoList()
  })

  useDebounceEffect(
    () => {
      window.addEventListener('FETCH_TODO_LIST', fetchMore)
      return () => {
        window.removeEventListener('FETCH_TODO_LIST', fetchMore)
      }
    },
    [chatState],
    { wait: 200 }
  )

  useDebounceEffect(
    () => {
      const key = getKey(chatState)
      if (!messageData[key] && chatState.chatActive?.code) {
        fetchTodoMessage(chatState.chatActive).then(messageItems => {
          // appendMessageData([messageItem, ...messageItems])
          setMessageData(key, [...messageItems])

          setTimeout(() => {
            // chatRef.current?.scrollToBottom?.()
            // fetchUnCount(d.id)
            triggerEvent('SCROLL_TO_BOTTOM')
          }, 0)
        })
      } else {
        setTimeout(() => {
          // chatRef.current?.scrollTop?.(messageState.scroll[d.id])
        }, 0)
      }
    },
    [chatState.chatActive],
    { wait: 200 }
  )

  const onTabSelect = record => {
    setChatState({
      todoTabKey: record.key,
    })
    setTimeout(() => {
      clearInterval(fetchMoreTimer)
    })
  }

  const handleSelect = d => {
    clearInterval(fetchMoreTimer)
    props.onSelect?.(d, chatState.chatTabKey + chatState.todoTabKey)
  }

  return (
    <Spin spinning={state.loading}>
      <ChatList
        {...props}
        onSelect={handleSelect}
        data={todoData[chatState.todoTabKey]}
        defaultHeight={'calc(100vh - 182px)'}
        hideBadge={chatState.todoTabKey !== 'TODO'}
        slot={{
          header: (
            <Row gutter={8} style={{ padding: '0 14px 18px' }}>
              {[
                {
                  key: 'TODO',
                  label: '待处理的',
                },
                {
                  key: 'STARTER',
                  label: '我发起的',
                },
                {
                  key: 'COMPLETED',
                  label: '已完成',
                },
              ].map?.((d, i) => {
                const active = chatState.todoTabKey === d.key
                return (
                  <Col key={`tab_${i}`} span={8}>
                    <div
                      className={classNames(styles.subItems, { [styles.active]: active })}
                      onClick={() => onTabSelect(d)}
                    >
                      {d.label}
                    </div>
                  </Col>
                )
              })}
            </Row>
          ),
        }}
      />
    </Spin>
  )
}

export const TodoDialog = props => {
  const chatRef = useRef<any>()

  const { chatState, messageData, setScroll, messageState } = useChatStore(
    useShallow((state: any) => ({
      chatState: state.chatState,
      messageData: state.messageData,
      setScroll: state.setScroll,
      messageState: state.messageState,
    }))
  )

  const todoKey = getKey(chatState)

  const handleReachTop = useCallback(
    throttle(() => {
      fetchMoreTimer = setTimeout(() => {
        triggerEvent('FETCH_TODO_LIST')
      }, 0)
    }, 600),
    []
  )

  const handleScrollFrame = values => {
    const _key = getKey(chatState)
    setScroll(values.scrollTop, _key)
  }

  const todoDialogProps = {
    onScroll: handleScrollFrame,
    messageData: messageData[todoKey] || [],
    defaultScrollTop: messageState.scroll[todoKey],
    noMore: messageState.noMore[todoKey],
    loading: messageState.loading[todoKey],
    data: chatState.activeDict[chatState.chatTabKey + chatState.todoTabKey],
  }
  return (
    <ChatDialog
      {...props}
      {...todoDialogProps}
      ref={chatRef}
      onReachTop={handleReachTop}
      hideInput
      deps={[chatState.todoTabKey]}
    />
  )
}

TodoList.Dialog = TodoDialog

export default TodoList
